const OrderInfo = ({ order, formatDate }) => {
    const normalizedStatus = order.status.charAt(0).toUpperCase() + order.status.slice(1).toLowerCase();
    return (
      <div className="mb-8 p-4 border rounded-lg shadow-md bg-gray-50 overflow-x-scroll">
        <h2 className="text-lg font-bold text-secondary">Order ID: {order._id}</h2>
        <div className="grid md:grid-cols-2 gap-4 mt-2">
          <div>
            <p className={`text-md font-medium ${normalizedStatus === 'Delivered' ? 'text-green-600' : normalizedStatus === 'Cancelled' ? 'text-red-600' : 'text-yellow-600'}`}>
              Status: {normalizedStatus}
            </p>
            <p className="text-sm text-gray-700">Order Date: {formatDate(order.createdAt)}</p>
            <p className="text-sm text-gray-700">Last Updated: {formatDate(order.updatedAt)}</p>
          </div>
          <div>
            <p className="text-sm text-gray-700">Transaction ID: {order.transactionId}</p>
            <p className="text-sm text-gray-700">Customer: {order.userId.fullName}</p>
            <p className="text-sm text-gray-700">Email: {order.userId.email}</p>
          </div>
        </div>
      </div>
    );
  };

  export default OrderInfo